var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "flex justify-content-between" }, [
          _c(
            "div",
            { staticClass: "pr-2", staticStyle: { flex: "1" } },
            [
              _c("DrugSearchNew", {
                ref: "drugSearch",
                attrs: { onSelect: _vm.getDrugData },
              }),
              _vm._v(" "),
              _vm.selectedDrug &&
              (_vm.selectedDrug.pack_box_comment ||
                _vm.selectedDrug.pack_comment)
                ? _c("div", { staticClass: "alert alert-info p-2 mb-0 mt-1" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.selectedDrug.pack_box_comment) +
                        "\n            " +
                        _vm._s(_vm.selectedDrug.pack_comment) +
                        "\n          "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-info",
                on: {
                  click: function ($event) {
                    return _vm.getAllStoreData()
                  },
                },
              },
              [_vm._v("Показать все препараты")]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.loading || (_vm.selectedDrugs && _vm.selectedDrugs.length)
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("pulse-loader", {
                staticClass: "text-center",
                attrs: { loading: _vm.loading, color: _vm.loadingColor },
              }),
              _vm._v(" "),
              !_vm.loading && (_vm.selectedDrug || _vm.storeData)
                ? _c(
                    "div",
                    [
                      false
                        ? _c(
                            "table",
                            { staticClass: "table table-sm table-hover" },
                            [
                              _vm._m(1),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                [
                                  _vm._l(_vm.selectedDrugs, function (drug) {
                                    return _vm.storeData.inStores[drug.id]
                                      ? [
                                          _c("tr", { staticClass: "main_tr" }, [
                                            _c(
                                              "td",
                                              {
                                                attrs: {
                                                  rowspan: _vm.getRecordsCount(
                                                    drug.id
                                                  ),
                                                },
                                              },
                                              [_vm._v(_vm._s(drug.id))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                attrs: {
                                                  rowspan: _vm.getRecordsCount(
                                                    drug.id
                                                  ),
                                                },
                                              },
                                              [
                                                _vm.allowToGetMoves
                                                  ? [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: _vm.getExternalLink(
                                                              drug
                                                            ),
                                                            target: "_blank",
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "icon-fa icon-fa-external-link",
                                                          }),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "pointer",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.mixinGoToRouter(
                                                                "NomenclatureStatistics",
                                                                {
                                                                  drugId:
                                                                    drug.id,
                                                                }
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(drug.title)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  : [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(drug.title) +
                                                          "\n                "
                                                      ),
                                                    ],
                                                _vm._v(" "),
                                                drug.pack_set &&
                                                drug.pack_set != 1
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "mb-0 badge badge-info",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "комплект x\n                  " +
                                                            _vm._s(
                                                              drug.pack_set
                                                            )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          !_vm.drugInstoresExists(drug)
                                            ? [
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: { colspan: "10" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Препарата нет ни на одном складе"
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            : _vm._l(
                                                _vm.$AllStores,
                                                function (store) {
                                                  return (_vm.storeData
                                                    .inStores[drug.id] &&
                                                    _vm.storeData.inStores[
                                                      drug.id
                                                    ][store.id]) ||
                                                    (_vm.storeData.requests[
                                                      drug.id
                                                    ] &&
                                                      _vm.storeData.requests[
                                                        drug.id
                                                      ][store.id]) ||
                                                    (_vm.storeData
                                                      .transitDetails[
                                                      drug.id
                                                    ] &&
                                                      _vm.storeData
                                                        .transitDetails[
                                                        drug.id
                                                      ][store.id])
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            class: {
                                                              grey_field:
                                                                store.id === 3,
                                                            },
                                                            attrs: {
                                                              width: "250px",
                                                            },
                                                          },
                                                          [
                                                            _vm.allowToGetMoves
                                                              ? [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      attrs: {
                                                                        href: _vm.getExternalLink(
                                                                          drug,
                                                                          store.id
                                                                        ),
                                                                        target:
                                                                          "_blank",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "icon-fa icon-fa-external-link",
                                                                      }),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "pointer",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.mixinGoToRouter(
                                                                              "NomenclatureStatistics",
                                                                              {
                                                                                drugId:
                                                                                  drug.id,
                                                                                storeId:
                                                                                  store.id,
                                                                              }
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          store.title
                                                                        ) +
                                                                          " (" +
                                                                          _vm._s(
                                                                            store.id
                                                                          ) +
                                                                          ")"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              : [
                                                                  _vm._v(
                                                                    "\n                    " +
                                                                      _vm._s(
                                                                        store.title
                                                                      ) +
                                                                      "\n                  "
                                                                  ),
                                                                ],
                                                          ],
                                                          2
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "grey_field w_store_d",
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  Math.round(
                                                                    _vm
                                                                      .storeData
                                                                      .inStores[
                                                                      drug.id
                                                                    ][
                                                                      store.id
                                                                    ] * 10
                                                                  ) / 10 || 0
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "w_store_d",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  (_vm.storeData
                                                                    .actualStoreData[
                                                                    drug.id
                                                                  ] &&
                                                                    _vm
                                                                      .storeData
                                                                      .actualStoreData[
                                                                      drug.id
                                                                    ][
                                                                      store.id
                                                                    ]) ||
                                                                    0
                                                                ) +
                                                                "\n                "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "w_store_d",
                                                          },
                                                          [
                                                            _vm.storeData
                                                              .requests &&
                                                            _vm.storeData
                                                              .requests[
                                                              drug.id
                                                            ] &&
                                                            _vm.storeData
                                                              .requests[
                                                              drug.id
                                                            ][store.id] &&
                                                            _vm.storeData
                                                              .requests[
                                                              drug.id
                                                            ][store.id][
                                                              _vm.reserveTypes
                                                                .appointedReserve
                                                            ] &&
                                                            _vm.storeData
                                                              .requests[
                                                              drug.id
                                                            ][store.id][
                                                              _vm.reserveTypes
                                                                .appointedReserve
                                                            ].qty
                                                              ? [
                                                                  _vm
                                                                    .showStoreDataTooltip[
                                                                    drug.id
                                                                  ]
                                                                    ? [
                                                                        _c(
                                                                          "v-popover",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                popoverClass:
                                                                                  "1111 p-3",
                                                                                popoverInnerClass:
                                                                                  "upload_file_component_popover",
                                                                                update:
                                                                                  (
                                                                                    open
                                                                                  ) => {
                                                                                    _vm.console.log(
                                                                                      "111",
                                                                                      open
                                                                                    )
                                                                                  },
                                                                                "close-directive":
                                                                                  () => {
                                                                                    _vm.console.log(
                                                                                      "1112"
                                                                                    )
                                                                                  },
                                                                                trigger:
                                                                                  "hover",
                                                                                "auto-hide": true,
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "badge badge-dark pointer fs-12",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                          " +
                                                                                    _vm._s(
                                                                                      _vm
                                                                                        .storeData
                                                                                        .requests[
                                                                                        drug
                                                                                          .id
                                                                                      ][
                                                                                        store
                                                                                          .id
                                                                                      ][
                                                                                        _vm
                                                                                          .reserveTypes
                                                                                          .appointedReserve
                                                                                      ]
                                                                                        .qty
                                                                                    ) +
                                                                                    "\n                        "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot: "popover",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "pre_image",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                            Заявки:\n                            "
                                                                                    ),
                                                                                    _vm._l(
                                                                                      _vm
                                                                                        .storeData
                                                                                        .requests[
                                                                                        drug
                                                                                          .id
                                                                                      ][
                                                                                        store
                                                                                          .id
                                                                                      ][
                                                                                        _vm
                                                                                          .reserveTypes
                                                                                          .appointedReserve
                                                                                      ]
                                                                                        .orders,
                                                                                      function (
                                                                                        o
                                                                                      ) {
                                                                                        return _c(
                                                                                          "p",
                                                                                          {
                                                                                            staticClass:
                                                                                              "mb-1",
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              "\n                              " +
                                                                                                _vm._s(
                                                                                                  o
                                                                                                )
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      }
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "p",
                                                                                      [
                                                                                        _c(
                                                                                          "a",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                href: "#",
                                                                                              },
                                                                                            on: {
                                                                                              click:
                                                                                                function (
                                                                                                  $event
                                                                                                ) {
                                                                                                  $event.preventDefault()
                                                                                                  return _vm.openInNewPage(
                                                                                                    "searchOrder",
                                                                                                    {
                                                                                                      ordersId:
                                                                                                        _vm
                                                                                                          .storeData
                                                                                                          .requests[
                                                                                                          drug
                                                                                                            .id
                                                                                                        ][
                                                                                                          store
                                                                                                            .id
                                                                                                        ][
                                                                                                          _vm
                                                                                                            .reserveTypes
                                                                                                            .appointedReserve
                                                                                                        ]
                                                                                                          .orders,
                                                                                                    }
                                                                                                  )
                                                                                                },
                                                                                            },
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              "\n                                Показать заявки\n                              "
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  2
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ]
                                                                    : [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "badge badge-dark pointer fs-12",
                                                                            on: {
                                                                              mouseover:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  _vm.showStoreDataTooltip[
                                                                                    drug.id
                                                                                  ] = true
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                        " +
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .storeData
                                                                                    .requests[
                                                                                    drug
                                                                                      .id
                                                                                  ][
                                                                                    store
                                                                                      .id
                                                                                  ][
                                                                                    _vm
                                                                                      .reserveTypes
                                                                                      .appointedReserve
                                                                                  ]
                                                                                    .qty
                                                                                ) +
                                                                                "\n                      "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                ]
                                                              : [_vm._v("0")],
                                                          ],
                                                          2
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "w_store_d",
                                                          },
                                                          [
                                                            _vm.storeData
                                                              .requests &&
                                                            _vm.storeData
                                                              .requests[
                                                              drug.id
                                                            ] &&
                                                            _vm.storeData
                                                              .requests[
                                                              drug.id
                                                            ][store.id] &&
                                                            _vm.storeData
                                                              .requests[
                                                              drug.id
                                                            ][store.id][
                                                              _vm.reserveTypes
                                                                .noAppointedReserve
                                                            ] &&
                                                            _vm.storeData
                                                              .requests[
                                                              drug.id
                                                            ][store.id][
                                                              _vm.reserveTypes
                                                                .noAppointedReserve
                                                            ].qty
                                                              ? [
                                                                  _vm
                                                                    .showStoreDataTooltip[
                                                                    drug.id
                                                                  ]
                                                                    ? [
                                                                        _c(
                                                                          "v-popover",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                popoverClass:
                                                                                  "1111 p-3",
                                                                                popoverInnerClass:
                                                                                  "upload_file_component_popover",
                                                                                update:
                                                                                  (
                                                                                    open
                                                                                  ) => {
                                                                                    _vm.console.log(
                                                                                      "111",
                                                                                      open
                                                                                    )
                                                                                  },
                                                                                "close-directive":
                                                                                  () => {
                                                                                    _vm.console.log(
                                                                                      "1112"
                                                                                    )
                                                                                  },
                                                                                trigger:
                                                                                  "hover",
                                                                                "auto-hide": true,
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "badge badge-dark pointer fs-12",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                          " +
                                                                                    _vm._s(
                                                                                      _vm
                                                                                        .storeData
                                                                                        .requests[
                                                                                        drug
                                                                                          .id
                                                                                      ][
                                                                                        store
                                                                                          .id
                                                                                      ][
                                                                                        _vm
                                                                                          .reserveTypes
                                                                                          .noAppointedReserve
                                                                                      ]
                                                                                        .qty
                                                                                    ) +
                                                                                    "\n                        "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot: "popover",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "pre_image",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                            Заявки:\n                            "
                                                                                    ),
                                                                                    _vm._l(
                                                                                      _vm
                                                                                        .storeData
                                                                                        .requests[
                                                                                        drug
                                                                                          .id
                                                                                      ][
                                                                                        store
                                                                                          .id
                                                                                      ][
                                                                                        _vm
                                                                                          .reserveTypes
                                                                                          .noAppointedReserve
                                                                                      ]
                                                                                        .orders,
                                                                                      function (
                                                                                        o
                                                                                      ) {
                                                                                        return _c(
                                                                                          "p",
                                                                                          {
                                                                                            staticClass:
                                                                                              "mb-1",
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              "\n                              " +
                                                                                                _vm._s(
                                                                                                  o
                                                                                                )
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      }
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "p",
                                                                                      [
                                                                                        _c(
                                                                                          "a",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                href: "#",
                                                                                              },
                                                                                            on: {
                                                                                              click:
                                                                                                function (
                                                                                                  $event
                                                                                                ) {
                                                                                                  $event.preventDefault()
                                                                                                  return _vm.openInNewPage(
                                                                                                    "searchOrder",
                                                                                                    {
                                                                                                      ordersId:
                                                                                                        _vm
                                                                                                          .storeData
                                                                                                          .requests[
                                                                                                          drug
                                                                                                            .id
                                                                                                        ][
                                                                                                          store
                                                                                                            .id
                                                                                                        ][
                                                                                                          _vm
                                                                                                            .reserveTypes
                                                                                                            .noAppointedReserve
                                                                                                        ]
                                                                                                          .orders,
                                                                                                    }
                                                                                                  )
                                                                                                },
                                                                                            },
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              "\n                                Показать заявки\n                              "
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  2
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ]
                                                                    : [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "badge badge-dark pointer fs-12",
                                                                            on: {
                                                                              mouseover:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  _vm.showStoreDataTooltip[
                                                                                    drug.id
                                                                                  ] = true
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                        " +
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .storeData
                                                                                    .requests[
                                                                                    drug
                                                                                      .id
                                                                                  ][
                                                                                    store
                                                                                      .id
                                                                                  ][
                                                                                    _vm
                                                                                      .reserveTypes
                                                                                      .noAppointedReserve
                                                                                  ]
                                                                                    .qty
                                                                                ) +
                                                                                "\n                      "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                ]
                                                              : [_vm._v("0")],
                                                          ],
                                                          2
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "w_store_d",
                                                          },
                                                          [
                                                            _vm.storeData
                                                              .transitDetails[
                                                              drug.id
                                                            ] &&
                                                            _vm.storeData
                                                              .transitDetails[
                                                              drug.id
                                                            ][store.id]
                                                              ? [
                                                                  _vm
                                                                    .showStoreDataTooltip[
                                                                    drug.id
                                                                  ]
                                                                    ? [
                                                                        _c(
                                                                          "v-popover",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                popoverClass:
                                                                                  "1111 p-3",
                                                                                popoverInnerClass:
                                                                                  "upload_file_component_popover",
                                                                                trigger:
                                                                                  "hover",
                                                                                "auto-hide": true,
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "badge badge-dark pointer fs-12",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                          " +
                                                                                    _vm._s(
                                                                                      _vm.getTransitQty(
                                                                                        _vm
                                                                                          .storeData
                                                                                          .transitDetails[
                                                                                          drug
                                                                                            .id
                                                                                        ][
                                                                                          store
                                                                                            .id
                                                                                        ]
                                                                                      )
                                                                                    ) +
                                                                                    "\n                        "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot: "popover",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "pre_image",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                            Накладные:\n                            "
                                                                                    ),
                                                                                    _vm
                                                                                      .storeData
                                                                                      .transitDetails[
                                                                                      drug
                                                                                        .id
                                                                                    ][
                                                                                      store
                                                                                        .id
                                                                                    ]
                                                                                      .details_in
                                                                                      ? [
                                                                                          _c(
                                                                                            "p",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Поступление:"
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _vm._l(
                                                                                            _vm
                                                                                              .storeData
                                                                                              .transitDetails[
                                                                                              drug
                                                                                                .id
                                                                                            ][
                                                                                              store
                                                                                                .id
                                                                                            ]
                                                                                              .details_in,
                                                                                            function (
                                                                                              i
                                                                                            ) {
                                                                                              return _c(
                                                                                                "p",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "mb-1",
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "\n                                " +
                                                                                                      _vm._s(
                                                                                                        i.invoice_id
                                                                                                      ) +
                                                                                                      " (" +
                                                                                                      _vm._s(
                                                                                                        i.qty
                                                                                                      ) +
                                                                                                      ")"
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      : _vm._e(),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _vm
                                                                                      .storeData
                                                                                      .transitDetails[
                                                                                      drug
                                                                                        .id
                                                                                    ][
                                                                                      store
                                                                                        .id
                                                                                    ]
                                                                                      .details_out
                                                                                      ? [
                                                                                          _c(
                                                                                            "p",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Отправка:"
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _vm._l(
                                                                                            _vm
                                                                                              .storeData
                                                                                              .transitDetails[
                                                                                              drug
                                                                                                .id
                                                                                            ][
                                                                                              store
                                                                                                .id
                                                                                            ]
                                                                                              .details_out,
                                                                                            function (
                                                                                              i
                                                                                            ) {
                                                                                              return _c(
                                                                                                "p",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "mb-1",
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "\n                                " +
                                                                                                      _vm._s(
                                                                                                        i.invoice_id
                                                                                                      ) +
                                                                                                      " (" +
                                                                                                      _vm._s(
                                                                                                        i.qty
                                                                                                      ) +
                                                                                                      ")"
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      : _vm._e(),
                                                                                  ],
                                                                                  2
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ]
                                                                    : [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "badge badge-dark pointer fs-12",
                                                                            on: {
                                                                              mouseover:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  _vm.showStoreDataTooltip[
                                                                                    drug.id
                                                                                  ] = true
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                        " +
                                                                                _vm._s(
                                                                                  _vm.getTransitQty(
                                                                                    _vm
                                                                                      .storeData
                                                                                      .transitDetails[
                                                                                      drug
                                                                                        .id
                                                                                    ][
                                                                                      store
                                                                                        .id
                                                                                    ]
                                                                                  )
                                                                                ) +
                                                                                "\n                      "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                ]
                                                              : [_vm._v("0")],
                                                          ],
                                                          2
                                                        ),
                                                      ])
                                                    : _vm._e()
                                                }
                                              ),
                                        ]
                                      : _vm._e()
                                  }),
                                ],
                                2
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.storeData
                        ? _c("StoreTable", {
                            attrs: {
                              showDrugTitle: true,
                              allowToGetMoves: _vm.allowToGetMoves,
                              selectedDrugs: _vm.selectedDrugs,
                              storeData: _vm.storeData,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("back-to-top", { attrs: { bottom: "50px", right: "50px" } }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info btn-to-top",
                    attrs: { type: "button" },
                  },
                  [_c("i", { staticClass: "icon-fa icon-fa-chevron-up" })]
                ),
              ]),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Остатки на складах")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Морион")]),
        _vm._v(" "),
        _c("th", [_vm._v("Наименование")]),
        _vm._v(" "),
        _c("th", [_vm._v("Склад")]),
        _vm._v(" "),
        _c("th", [_vm._v("Наличие")]),
        _vm._v(" "),
        _c("th", [_vm._v("Фактич")]),
        _vm._v(" "),
        _c("th", [_vm._v("Р. бронь")]),
        _vm._v(" "),
        _c("th", [_vm._v("Не р. бронь")]),
        _vm._v(" "),
        _c("th", [_vm._v("В дороге")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }